import type { City, Searchable } from 'shared/types'
import { client } from '../clients'

const search = (params: Searchable) => client.get<City[]>('/cities', { params })

export const cities = {
  search
}
